import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Modal,
  Tooltip,
  CircularProgress,
} from '@mui/material';
// import formatDateToRelative from '../utils/dateFormat';

// components
import Label from '../../components/label';
import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
import apiFunctions from '../../API/api';
// sections
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
// mock
import USERLIST from '../../_mock/user';
import { useFilter } from '../../layouts/dashboard/FilterProvider';
import WhatsappApiFunctions from '../../API/whatsapp';
import DropdownWithSearch from './DropDownWithSearch';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'sno', label: 'S.NO', alignRight: false },
  // { id: 'StoreId', label: 'Store Id', alignRight: false },
  // { id: 'loc', label: 'Name', alignRight: false },
  // { id: 'QrCode', label: 'QrCode', alignRight: false },
  { id: 'Number', label: 'Number', alignRight: false },
  { id: 'Status', label: 'Status', alignRight: false },
  { id: 'TemplateName', label: 'Template Name', alignRight: false },
  { id: 'FileName', label: 'Event Name', alignRight: false },
  { id: 'CreatedAt', label: 'Created At', alignRight: false },
  // { id: 'role', label: 'Role', alignRight: false },
  // { id: 'isVerified', label: 'Verified', alignRight: false },
  // { id: 'CreatedAt', label: 'Created At', alignRight: false },
];

const TABLE_HEAD_2 = [
  { id: 'UserName', label: 'Name', alignRight: false },
  // { id: 'loc', label: 'Name', alignRight: false },
  { id: 'Number', label: 'Store Codewerwr', alignRight: false },
  { id: 'Number', label: 'Location', alignRight: false },
  // { id: 'role', label: 'Role', alignRight: false },
  // { id: 'isVerified', label: 'Verified', alignRight: false },
  { id: 'CreatedAt', label: 'Created At', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  // Filter out null values first
  const filteredArray = array.filter((item) => item !== null);

  const stabilizedThis = filteredArray.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(filteredArray, (_user) => _user?.Number?.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}
function formatToIST(dateString) {
  // Convert the input date string to a Date object
  const date = new Date(dateString);

  // Get the individual components
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  // Determine AM or PM
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Convert hours to 12-hour format
  hours %= 12;
  hours = hours || 12; // If hours is 0, make it 12

  // Format the time to include leading zeros
  const formattedTime = `${hours}:${minutes < 10 ? `0${minutes}` : minutes} ${ampm}`;

  // Get the year (last two digits)
  const year = `${date.getFullYear()}`.slice(-2);

  // Return the formatted date and time string
  return `${date.getDate()}/${date.getMonth() + 1}/${year} ${formattedTime}`;
}
function formatDateToRelative(dateString) {
  const ISTOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds (5 hours 30 minutes)

  // Convert the given date string to a Date object and add the IST offset
  const utcDate = new Date(dateString);
  const ISTDate = new Date(utcDate.getTime() + ISTOffset);

  const now = new Date();
  const timeDifference = now - ISTDate;
  const secondsDifference = Math.floor(timeDifference / 1000);
  const minutesDifference = Math.floor(secondsDifference / 60);
  const hoursDifference = Math.floor(minutesDifference / 60);
  const daysDifference = Math.floor(hoursDifference / 24);
  const weeksDifference = Math.floor(daysDifference / 7);
  const monthsDifference = Math.floor(daysDifference / 30);
  const yearsDifference = Math.floor(daysDifference / 365);

  if (yearsDifference >= 1) {
    return `${yearsDifference} year${yearsDifference > 1 ? 's' : ''} ago`;
  }
  if (monthsDifference >= 1) {
    return `${monthsDifference} month${monthsDifference > 1 ? 's' : ''} ago`;
  }
  if (weeksDifference >= 1) {
    return `${weeksDifference} week${weeksDifference > 1 ? 's' : ''} ago`;
  }
  if (daysDifference >= 1) {
    return `${daysDifference} day${daysDifference > 1 ? 's' : ''} ago`;
  }
  if (hoursDifference >= 1) {
    return `${hoursDifference} hour${hoursDifference > 1 ? 's' : ''} ago`;
  }
  if (minutesDifference >= 1) {
    return `${minutesDifference} minute${minutesDifference > 1 ? 's' : ''} ago`;
  }

  return `${secondsDifference} second${secondsDifference > 1 ? 's' : ''} ago`;
}

const DigitalMessageTable = forwardRef(({ selectedStore, openLoader, closeLoader, selectedTemplate, selectedStatus, filterDate, tableData, totalCount, tableLoading, onPageChange, onSearchChange, resetKey }, ref) => {
  // console.log('props:', props);
  // console.log('ref :', ref);

  const { setFilter, filter } = useFilter();

  console.log('filter : ', filter);

  // Data is now managed by parent component

  // Data now comes from parent component as props
  // const [USERLIST, setUserList] = useState([]);
  // const [totalUser, setTotalUser] = useState(0);
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  const [selectedValue, setSelectedValue] = useState(null);
  const dropdownOptions = [
    { label: 'Apple', value: 1 },
    { label: 'Banana', value: 2 },
    { label: 'Orange', value: 3 },
    { label: 'Grapes', value: 4 },
    { label: 'Mango', value: 5 },
  ];


  // API calls are now handled by parent component

  // Data loading is now handled by parent component

  useImperativeHandle(ref, () => ({
    refresh() {
      console.log('🔄 DigitalMessageTable: Refresh requested - handled by parent');
      setPage(0);
    },
    callChildFunction() {
      console.log('🔄 DigitalMessageTable: Call child function requested - handled by parent');
      setPage(0);
    },
  }));

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.filter((n) => n && n.name).map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // Call parent's page change handler
    if (onPageChange) {
      onPageChange(newPage, rowsPerPage);
    }
    console.log('Page changed to:', newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);

    // Call parent's page change handler with new page size
    if (onPageChange) {
      onPageChange(0, newRowsPerPage);
    }
  };

  // Debounced search -> send to parent for server-side filter
  const debouncedSearchTimeoutRef = useRef(null);

  const handleFilterByName = (event) => {
    setPage(0);
    const searchValue = event.target.value;
    setFilterName(searchValue);

    if (debouncedSearchTimeoutRef.current) {
      clearTimeout(debouncedSearchTimeoutRef.current);
    }
    debouncedSearchTimeoutRef.current = setTimeout(() => {
      if (onSearchChange) {
        onSearchChange(searchValue);
      }
    }, 600);
  };

  useEffect(() => {
    return () => {
      if (debouncedSearchTimeoutRef.current) {
        clearTimeout(debouncedSearchTimeoutRef.current);
      }
    };
  }, []);

  // Reset pagination when resetKey changes (triggered by refresh button)
  useEffect(() => {
    if (resetKey > 0) {
      setPage(0);
      setRowsPerPage(5);
      console.log('🔄 DigitalMessageTable: Pagination reset to page 0');
    }
  }, [resetKey]);

  const emptyRows = 0; // No empty rows needed for server-side pagination

  const filteredUsers = tableData;

  const isNotFound = !filteredUsers.length && !!filterName;

  const matchColor = {
    Delivered: 'gray',
    Failed: 'red',
    Pending: 'orange',
    Read: 'Green',
  };


  return (
    <>
      <Helmet>
        <title> Xploro </title>
      </Helmet>

      <>
        {/* <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            User
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            New User  
          </Button>
        </Stack> */}

        <Card>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mr={2}>
            <UserListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              tableType={'Number'}
            />
            <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
              {/* Template select moved to parent component */}
            </Stack>
          </Stack>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, minHeight: '340px' }}>
              <Table>
                <UserListHead
                  order={order}
                  // orderBy={orderBy}
                  headLabel={filter.type === '' ? TABLE_HEAD : TABLE_HEAD_2}
                  rowCount={totalCount}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {tableLoading ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 2 }}>
                          Loading data...
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredUsers
                      .filter((row) => row !== null)
                      .map((row, index) => {
                      const { StoreId, QrCode, Name, Message, CreatedAt, Email } = row || {};
                      const selectedUser = Name ? selected.indexOf(Name) !== -1 : false;

                      return (
                        <TableRow hover key={index} tabIndex={-1} role="checkbox" selected={selectedUser}>
                          {/* <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, name)} />
                        </TableCell> */}
                          <TableCell component="th" scope="row" padding="1">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {page * rowsPerPage + (index + 1)}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">{row.Number}</TableCell>
                          <TableCell align="left">
                            <Stack direction="column">
                              <Typography
                                sx={{
                                  color: matchColor[row.MessageStatus],
                                  fontSize: '0.8rem',
                                  // width: 'max-content',
                                  display: 'flex',
                                  direction: 'row',
                                  alignItems: 'center',
                                  gap: '0.2rem',
                                  maxWidth: '13vw',
                                  minWidth: '12vw',
                                }}
                              >
                                {row.MessageStatus}
                              </Typography>
                              <Typography sx={{ fontSize: '0.6rem', color: 'gray', width: '12vw', overflow: 'hidden' }}>
                                {row.MessageStatus === 'Failed' && `[ ${row.ErrorMsg} ]`}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">
                            <Typography
                              sx={{
                                width: '12vw',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              <Tooltip sx={{ color: 'gray' }} color="gray !important" title={row.TemplateName}>
                                <span>{row.TemplateName}</span>
                              </Tooltip>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography
                              sx={{
                                width: '7vw',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              <Tooltip sx={{ color: 'gray' }} color="gray !important" title={row.EventsName}>
                                <span>{row.EventsName}</span>
                              </Tooltip>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">{formatToIST(row.CreatedAt)}</TableCell>
                        </TableRow>
                      );
                    })
                  )}
                  {!isNotFound && filteredUsers.length === 0 && (
                    <TableRow rowSpan={6} colSpan={6}>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            No data available
                          </Typography>

                          <Typography variant="body2">No file added in this campaign</Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
                {/* {USERLIST?.length === 0 &&
                    <TableBody>
                    <TableRow rowSpan={5}>
                      <TableCell align="center" colSpan={6} rowSpan={5} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not data found
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                } */}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            // showFirstButton
            // showLastButton
          />
        </Card>
      </>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>
        +
        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
});

export default DigitalMessageTable;
